import React from 'react';
import { useSelector } from 'react-redux';

// import { IRootState } from 'Types/index';

import * as Styles from './styles';
import CustomLoader from '../loader';

interface IGlobalLoaderProps {
    forceLoad?: boolean;
}

export default function GlobalLoader(props: IGlobalLoaderProps) {
    const { forceLoad } = props;

    const showGlobalLoader: boolean = useSelector(
        ({ garage }: any) => garage.loader
    );

    return forceLoad || showGlobalLoader ? <CustomLoader size={160} /> : null;
}
